export default {
  http: {
    OK: 200
  },
  exchangeNewIds: { BIN: 'BINANCE SPOT', BIF: 'BINANCE FUTURES', BIM: 'BINANCE MARGIN', EXM: 'EXMO SPOT', BIT: 'BITTREX', YOB: 'YOBIT', HUO: 'HTX SPOT', FTX: 'FTX', OKX: 'OKX (SPOT + FUTURES)', BYF: 'BYBIT FUTURES', BYB: 'BYBIT SPOT', GET: 'BITGET SPOT', GEF: 'BITGET FUTURES' },
  exchangeIds: { BIN: 'BINANCE', BIF: 'BINANCE FUTURES', BIM: 'BINANCE MARGIN', EXM: 'EXMO', BIT: 'BITTREX', YOB: 'YOBIT', HUO: 'HUOBI', FTX: 'FTX', OKX: 'OKX', BYF: 'BYBIT FUTURES', BYB: 'BYBIT SPOT', GET: 'BITGET SPOT', GEF: 'BITGET FUTURES' },
  exchangeTVIds: { BIN: 'BINANCE', BIM: 'BINANCE', BIF: 'FUTURES', EXM: 'EXMO', BIT: 'BITTREX', YOB: 'YOBIT', HUO: 'HUOBI', FTX: 'FTX', OKX: 'OKX', BYF: 'BYBIT FUTURES', BYB: 'BYBIT', GET: 'BITGET SPOT', GEF: 'BITGET FUTURES' },
  stables: { 'PAX': true, 'USD': true, 'USDT': true, 'USDC': true, 'USDS': true, 'TUSD': true, 'BUSD': true },
  isStableCoin (coin) {
    return (this.stables[coin] === true)
  },
  coinColors: {
    'BTC': '#FF9900',
    'BNB': '#FFDD00',
    'BUSD': '#60AA45',
    'DAI': '#68CA89',
    // 'USDT': '#3ACF61',
    'USDT': '#68E389',
    // 'TUSD': '#68E389',
    'TUSD': '#3ACF61',
    'USDC': '#84E358',
    'PAX': '#26AD4A',
    'GUSD': '#1B8F3A',
    'USDS': '#00CA88',
    'USD': '#84F958',
    'BTT': '#567880',
    'HUSD': '#26C44A',
    'BSV': '#EAB300',
    'EOS': '#64F2F0',
    'QTUM': '#3EB8F8',
    'ETH': '#8839B0',
    'ZRX': '#838188',
    'AE': '#DE3F6B',
    'REP': '#B82990',
    'BTG': '#DEA2D4',
    'BRD': '#FC5E81',
    'LINK': '#3F9DEB',
    'CND': '#D8D0EC',
    'CVC': '#009EBA',
    'DASH': '#278EE5',
    'MANA': '#C9A282',
    'DCR': '#EBD8A3',
    'DGB': '#096BC7',
    'DGD': '#A63FA3',
    'DNT': '#3587AA',
    'ETC': '#3587AA',
    'FUN': '#DC2C7E',
    'GVT': '#E98FF7',
    'GNO': '#0EA3BF',
    'GNT': '#01D3E0',
    'ICN': '#507DA6',
    'RLC': '#7329B0',
    'KNC': '#969491',
    'LTC': '#AEAEAE',
    'LRC': '#D8D7D8',
    'LUN': '#B7553C',
    'MKR': '#B3693C',
    'MTL': '#D2D2D2',
    'MITH': '#1068A7',
    'OMG': '#3A79FF',
    'POE': '#C4B0B0',
    'POLY': '#5869BB',
    'POWR': '#C09EBD',
    'REQ': '#73F9B0',
    'SALT': '#8869BB',
    'SNGLS': '#BE4561',
    'SNT': '#996308',
    'STORJ': '#727880',
    'STORM': '#A87B19',
    'TRX': '#D11E25',
    'VIB': '#FF1F42',
    'WINGS': '#E0D478',
    'XRP': '#00AAE4',
    'XLM': '#D4EEF7',
    'ADA': '#2870D4',
    'XMR': '#54616E',
    'NEM': '#6AB0E0',
    'WAVES': '#0055FE',
    'ONT': '#32A5BF',
    'ZIL': '#49C0BE',
    'XVG': '#0098BF',
    'PIVX': '#523C73',
    'THETA': '#B5B08D'
  },
  coinOtherColors:
    [
      '#8858BB',
      '#8860E7',
      '#8848B0',
      '#C9A268',
      '#C9A29D',
      '#B84590',
      '#FD3F6B',
      '#D646DC',
      '#9A46DC',
      '#885835',
      '#884635',
      '#9A4635',
      '#9A466B',
      '#72466B'
    ],
  defaultTerminalDashboardJSON: `[
    {
      "breakpoint":"xl",
      "breakpointWidth":1400,
      "numberOfCols":12,
      "rowHeight":10,
      "margin":{
        "x":15,
        "y":15
      },
      "items":[
        {
          "id":"Chart",
          "name":"ГРАФИК",
          "x":0,
          "y":0,
          "width":9,
          "height":24,
          "minHeight":10,
          "resizeEdges":"left right bottom",
          "locked":true
        },
        {
          "id":"SmartTrade",
          "name":"СДЕЛКА",
          "x":9,
          "y":0,
          "width":3,
          "height":24,
          "minHeight":10,
          "minWidth":2,
          "resizeEdges":"left right bottom",
          "locked":true
        },
        {
          "id":"MiniAssets",
          "name":"ПОРТФЕЛЬ",
          "x":0,
          "y":24,
          "width":3,
          "height":34,
          "minHeight":10,
          "component":"MiniAssets",
          "resizeEdges":"left right bottom",
          "locked":true
        },
        {
          "id":"Trades",
          "name":"СДЕЛКИ",
          "x":3,
          "y":24,
          "width":9,
          "height":34,
          "minHeight":10,
          "component":"Trades",
          "resizeEdges":"left right bottom",
          "locked":true
        }
      ],
      "deletedItems":[
        {
          "id":"Symbols",
          "name":"ПАРЫ",
          "x":0,
          "y":0,
          "width":4,
          "height":25,
          "minHeight":10,
          "component":"Symbols",
          "resizeEdges":"left right bottom",
          "locked":false
        },
        {
          "id":"OrderBook",
          "name":"СТАКАН",
          "x":3,
          "y":21,
          "width":3,
          "height":19,
          "minHeight":10,
          "component":"OrderBook",
          "resizeEdges":"left right bottom",
          "locked":false
        }
      ]
    },
    {
      "breakpoint":"lg",
      "breakpointWidth":1024,
      "numberOfCols":12,
      "rowHeight":10,
      "margin":{
        "x":5,
        "y":5
      },
      "items":[
        {
          "id":"Chart",
          "name":"ГРАФИК",
          "x":0,
          "y":0,
          "width":8,
          "height":33,
          "minHeight":10,
          "resizeEdges":"left right bottom",
          "locked":true
        },
        {
          "id":"SmartTrade",
          "name":"СДЕЛКА",
          "x":8,
          "y":0,
          "width":4,
          "height":33,
          "minHeight":10,
          "minWidth":2,
          "resizeEdges":"left right bottom",
          "locked":true
        },
        {
          "id":"MiniAssets",
          "name":"ПОРТФЕЛЬ",
          "x":0,
          "y":33,
          "width":3,
          "height":47,
          "minHeight":10,
          "component":"MiniAssets",
          "resizeEdges":"left right bottom",
          "locked":true
        },
        {
          "id":"Trades",
          "name":"СДЕЛКИ",
          "x":3,
          "y":33,
          "width":9,
          "height":47,
          "minHeight":10,
          "component":"Trades",
          "resizeEdges":"left right bottom",
          "locked":true
        }
      ],
      "deletedItems":[
        {
          "id":"Symbols",
          "name":"ПАРЫ",
          "x":0,
          "y":0,
          "width":4,
          "height":25,
          "minHeight":10,
          "component":"Symbols",
          "resizeEdges":"left right bottom",
          "locked":false
        },
        {
          "id":"OrderBook",
          "name":"СТАКАН",
          "x":0,
          "y":33,
          "width":4,
          "height":30,
          "minHeight":10,
          "component":"OrderBook",
          "resizeEdges":"left right bottom",
          "locked":false
        }
      ]
    }
  ]`,
  defaultScreenerDashboardJSON: `[
    {
      "breakpoint":"xl",
      "breakpointWidth":1400,
      "numberOfCols":12,
      "rowHeight":10,
      "margin":{
        "x":15,
        "y":15
      },
      "items":[]
    },
    {
      "breakpoint":"lg",
      "breakpointWidth":1024,
      "numberOfCols":12,
      "rowHeight":10,
      "margin":{
        "x":5,
        "y":5
      },
      "items":[]
    }
  ]`
}
